import { AxiosResponse } from 'axios';
import HttpClientWithRetry from '../../../http/client/HttpClientWithRetry';
import { TodoResponse } from '../types';

export class ToDoController {
  constructor(private readonly httpClient: HttpClientWithRetry) {}

  async getTodos(accountId: string, needCompleted: boolean): Promise<AxiosResponse<TodoResponse>> {
    const path = `/api/v1/account/${accountId}/dashboard/todos?needCompleted=${needCompleted}`;
    return this.httpClient.get<TodoResponse>(path);
  }

  async getUpcomingAppointments(
    accountId: string,
    todoCount?: number,
    interviewCount?: number,
    total?: number,
  ): Promise<AxiosResponse<TodoResponse>> {
    const params = new URLSearchParams();

    if (todoCount !== undefined) {
      params.append('toDo', String(todoCount));
    }

    if (interviewCount !== undefined) {
      params.append('interviewCount', String(interviewCount));
    }

    if (total !== undefined) {
      params.append('total', String(total));
    }

    const query = params.toString();
    const path = `/api/v1/account/${accountId}/dashboard/todos/upcomingInterviews${query ? `?${query}` : ''}`;
    return this.httpClient.get<TodoResponse>(path);
  }

  async updateStatus(
    userId: string,
    docId: string,
    status: string,
    category: string,
    subCategory: string | null,
    candidateId: string,
  ): Promise<void> {
    const path = `/api/v1/${userId}/dashboard/updateRecuiterActionStatus`;
    await this.httpClient.post(path, {
      docId,
      status,
      category,
      subCategory,
      candidateId,
    });
  }
}
